import { IconWrapper } from './IconWrapper.tsx';

interface DynamicIconProps {
  borderRadius?: number;
  fillOpacity?: number;
  width?: number;
  height?: number;
  lockAspectRatio?: boolean;
  icon: React.ComponentType<any>;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
}

export const DynamicIcon = ({
  borderRadius,
  fillOpacity,
  width,
  height,
  lockAspectRatio,
  icon: Icon,
  fill,
  stroke,
  strokeWidth,
}: DynamicIconProps) => (
  <IconWrapper data-testid="shape-icon-wrapper">
    <Icon
      fillOpacity={fillOpacity}
      borderRadius={borderRadius}
      width={width}
      height={height}
      lockAspectRatio={lockAspectRatio}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </IconWrapper>
);
